import { Card, Space, Typography } from "antd";

import { PayslipForm } from "../components/PayslipForm";

const { Title } = Typography;

const CreatePayslip = () => {
  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Create Payslip
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          Payslip Information
        </Title>

        <PayslipForm mode="create" />
      </Card>
    </Space>
  );
};

export default CreatePayslip;
